import { render } from "./Edi.vue?vue&type=template&id=2af94c98"
import script from "./Edi.vue?vue&type=script&lang=js"
export * from "./Edi.vue?vue&type=script&lang=js"

import "./Edi.vue?vue&type=style&index=0&id=2af94c98&lang=scss"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__